export const TabScrollModule = angular
    .module('app.directives.tabScroll', [])
    .directive('tabScroll', ($window, $timeout, $document) => {
        return {
            link: (scope, element, attrs) => {
                var cutoff = 0;
                var $$window = angular.element($window);
                var $pageHeader = angular.element('.page__header');
                var $pageStatus;
                var $trialBar;
                var $page;
                var $body = angular.element('body');
                var $$document = angular.element($document);
                var watcher = attrs.tabScrollWatch;

                var statusHeight = 0;
                var headerHeight = 0;
                var trialBarHeight = 0;

                // add fixed class after timeout to
                // prevent wrong positioning on load
                $timeout(() => {
                    $pageStatus = angular.element('.page__status');
                    $page = angular.element('.page');
                    $trialBar = angular.element('.trial-status-bar');
                    $$window.on('scroll', scrollManager);
                    $$window.on('resize orientationchange', resizeManager).resize();

                    if (watcher) {
                        scope.$watchCollection(watcher, () => $timeout(resizeManager));
                    }
                });

                scope.$on('$destroy', () => {
                    $$window.off('scroll', scrollManager);
                    $$window.off('resize orientationchange', resizeManager);
                });

                function scrollManager() {
                    var currScroll = $$window.scrollTop();

                    if ($$window.height() === $$document.height()) {
                        return;
                    }

                    if (!$body.hasClass('md-dialog-is-showing')) {
                        element.toggleClass('md-tabs--fixed', currScroll > cutoff);
                    }
                }

                function getCutoff($el) {
                    return $el.offset().top - headerHeight - statusHeight;
                }

                function checkVisibility($el) {
                    return !!($el && $el.length && $el.is(':visible'));
                }

                function resizeManager() {
                    element.toggleClass('md-tabs--has-status', checkVisibility($pageStatus));
                    headerHeight = $pageHeader.is(':visible') ? $pageHeader.height() : 0;
                    statusHeight = $pageStatus.is(':visible') ? $pageStatus.height() : 0;
                    trialBarHeight = $trialBar.is(':visible') ? $trialBar.height() : 0;

                    cutoff = getCutoff(element);

                    var wHeight = $$window.height();
                    var dHeight = $$document.height();
                    var maxScroll = dHeight - wHeight;
                    var heightNeeded = cutoff - maxScroll;
                    $page.css('min-height', Math.ceil(($page.height() + heightNeeded) - trialBarHeight));

                    scrollManager();
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/tabScroll.directive.js